<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form #auroraSubmitForm="ngForm"
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Entity_Name">Entity Name</label>
              <input
                myFocus
                type="text"
                name="Entity_Name"
                [(ngModel)]="dsCollection.criteria.Entity_Name"
                ngControl="Entity_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-8">
            <aurora-button
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              variant="primary"
              (click)="auroraSubmitForm.onSubmit($event)"
            >
              Search
            </aurora-button>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>
        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 1500px">
            <tr>
              <th *ngIf="this.model.criteria.Role_Type == 'BK'" style="width: 250px">Broker</th>
              <th *ngIf="this.model.criteria.Role_Type == 'SP'" style="width: 250px">Source Supplier</th>
              <th>Agreement Num</th>
              <th>Product Line</th>
              <th>Program</th>
              <th>State</th>
              <th>New Comm</th>
              <th>Renew Comm</th>
              <th>Rewrite Comm</th>
              <th>Endorse Comm</th>
              <th>Renew Endorse Comm</th>
              <th *ngIf="this.model.criteria.Role_Type == 'SP'">Risk Supplier</th>
            </tr>

            <tr *ngFor="let agreement of dsCollection.objectNodes" (click)="app.getSelectedText() && select(agreement)">
              <td *ngIf="this.model.criteria.Role_Type == 'BK'" style="width: 250px">
                {{ agreement.BrokerAgreement.Broker.Entity_Name }}
              </td>
              <td *ngIf="this.model.criteria.Role_Type == 'BK'">
                {{ agreement.BrokerAgreement.Agmt_Num }}
              </td>
              <td *ngIf="this.model.criteria.Role_Type == 'SP'" style="width: 250px">
                {{ agreement.SupplierAgreement.Supplier.Entity_Name }}
              </td>
              <td *ngIf="this.model.criteria.Role_Type == 'SP'">
                {{ agreement.SupplierAgreement.Agmt_Num }}
              </td>
              <td>
                {{ agreement.Line_Code }}
              </td>
              <td>
                {{ agreement.Program }}
              </td>
              <td>
                {{ agreement.State }}
              </td>
              <td>
                {{ agreement.New_Comm_Rate }}
              </td>
              <td>
                {{ agreement.Renewal_Comm_Rate }}
              </td>
              <td>
                {{ agreement.Rewrite_Comm_Rate }}
              </td>
              <td>
                {{ agreement.Endorse_Comm_Rate }}
              </td>
              <td>
                {{ agreement.Renewal_Endorse_Comm_Rate }}
              </td>
              <td *ngIf="this.model.criteria.Role_Type == 'SP'">
                {{ agreement.SupplierAgreement.Risk_Supplier.Entity_Name }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Agreements</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
